import React from 'react';
import StickyTableWrap from './StickyTableWrap';

/**
 * Remplace <div className="table-responsive"> autour d'un <table>.
 * En-tête figé sous la navbar au scroll de page.
 * Mode embedded (scroll interne) : thead sticky dans le conteneur.
 */
const StickyTableResponsive = ({
  children,
  className = '',
  embedded = false,
  style,
  ...rest
}) => {
  const isEmbedded = embedded || style?.maxHeight != null;

  if (isEmbedded) {
    return (
      <div
        className={`table-responsive app-table-embedded-sticky${className ? ` ${className}` : ''}`}
        style={style}
        {...rest}
      >
        {children}
      </div>
    );
  }

  return (
    <StickyTableWrap className={className} style={style} {...rest}>
      {children}
    </StickyTableWrap>
  );
};

export default StickyTableResponsive;
